import React from "react";
import { useNavigate } from "react-router-dom";

const RequestModal = ({ show, onClose }) => {
  const navigate = useNavigate(); // Hook must come before any conditional return

  if (!show) return null; // Safe now — hook already declared

  const handleRequest = () => {
    onClose(); // Close modal
    navigate("/home"); // Navigate to 
  };


  return (
    <div className="modal show custom-modall" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
           
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body text-center">
            <h5 style={{fontSize:"1.2rem"}}>Request Received <br/> -You're Almost There!</h5>
            <p className="mt-3">Thanks for requesting access to Blueberry Pediatrics. You'll receive an email within 24 hours with instructions to set up your Blueberry account and request your Home Kit.</p>
            <div className="d-flex flex-column gap-2">
              <button className="win-btn-primary-full" onClick={handleRequest}>Return to home</button>
            
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestModal;
